import {
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnInit,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TuiDialogContext, TuiDialogService } from "@taiga-ui/core";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { CodehelpService, HttpService } from "virtue-form";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { NotificationService } from "src/app/core/services/shared/notification.service";

@Component({
  selector: "app-profile-popup",
  templateUrl: "./profile-popup.component.html",
  styleUrls: ["./profile-popup.component.scss"],
})
export class ProfilePopupComponent implements OnInit {
  login_form!: FormGroup;
  erroremail: boolean = false;
  isValidField: boolean = false;
  awesome: boolean = true;
  // isAddMode: boolean = true;
  filesizeError: boolean = false;
  isuploadimage: boolean = false;
  IsLoadData: boolean = false;
  isWrongFileSelection: boolean = false;
  imageId: string = "";
  fullname: boolean = false;
  profile: any;
  userName: string = "";
  profilecheck: string = "";
  FullName: string = "";
  profileImage: string = "";
  Email: string = "";
  lastLogin: string = "";
  // Email= '';
  editprofiles: boolean = false;

  constructor(
    private codehelp: CodehelpService,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    private cdr: ChangeDetectorRef,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector,
    private globalvar: GlobalVarService,
    private httpser: HttpService,
    private apiService: ApiService,
    private notificatioService: NotificationService
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("user-profile");
  }

  ngOnInit(): void {
    let profile = JSON.parse(this.codehelp.getUserProfile() || "");
    this.FullName = profile?.fullName || "";
    this.Email = profile?.email || "";
    this.profileImage = profile?.avatar;
    this.userName = profile?.username || "";
    // let username =this.codehelp.getStoreValue('username');
    // if(username)
    // this.userName= username || '';
    let LogginInfo = JSON.parse(this.codehelp.getStoreValue("LoginInfo") || "");
    this.lastLogin = LogginInfo.lastLoggedInInfo?.time;
  }

  getFirstLetters(str) {
    const firstLetters = str
      .split(" ")
      .map((word) => word[0])
      .join("");

    return firstLetters;
  }
  close() {
    this.context.completeWith("");
    // const dialog = document.querySelector('tui-dialog');
    // dialog.classList.remove('user-profile');
  }
}
